// One place that decides what goes in the browser tab.
//
// The convention is trail-then-brand, most specific first:
//
//   pageTitle('Events')                 => "Events | Timelydo"
//   pageTitle('Bookings', 'Analytics')  => "Bookings | Analytics | Timelydo"
//
// Route definitions carry only the trail (`meta.title`), never the brand, so
// the suffix is applied once here instead of being repeated across every route
// and every component that sets a title of its own.

import { t, te } from 'utils/i18n.js'

const FALLBACK_NAME = 'Timelydo'

// Read at call time rather than at module load: `window.APPLICATION_NAME` is
// written by the Rails layout, and on a Turbo navigation this module is
// evaluated before that script has necessarily run again.
export function appName() {
  return window.APPLICATION_NAME || FALLBACK_NAME
}

export function titleKey(part) {
  const slug = String(part).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
  return `app.page_titles.${slug}`
}

// Each part of the trail is looked up in app.page_titles, by its English words. A part that has no
// entry (an event's name, an admin page) is shown as it is. Route definitions keep writing the
// English trail ("Bookings | Analytics"); it is split here so each word is translated on its own.
function translatePart(part) {
  const key = titleKey(part)
  return te(key) ? t(key) : part
}

export function pageTitle(...parts) {
  const trail = parts.filter(Boolean).flatMap((part) => String(part).split(' | ')).map(translatePart)
  return trail.length ? `${trail.join(' | ')} | ${appName()}` : appName()
}
